import React, { useEffect, useState } from 'react';
import { Card, Form, Select, Checkbox, Button, Row, Col, Breadcrumb, Space } from 'antd';
import { apiRequest } from '../../../service/apiRequest';
import { showSuccess, showError } from '../../../components/errorHandler';
import { useSelector } from 'react-redux';
import { Calendar, Badge } from 'antd';
import type { CalendarProps, BadgeProps } from 'antd';
import type { Dayjs } from 'dayjs';
import { EditOutlined } from '@ant-design/icons';
import EmployeeAttendanceModal from './EmployeeAttendanceModal';
import EmployeeLeaveModal from './EmployeeLeaveModal';
import dayjs from 'dayjs';


import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from "dayjs/plugin/duration";


dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

const IST_ZONE = 'Asia/Kolkata';


const { Option } = Select;

interface Ledgers {
    ledger_id: number;
    ledger_first_name: string;
    ledger_last_name: string;
    ledger_name: string;
    ledger_occupation: string;
}

interface EmployeeAttendanceRecord {
    attendance_id: number;
    attendance_ledger_id: number;
    attendance_date: string;
    attendance_in: string;
    attendance_out: string;
    attendance_type: string;
    attendance_remark: string;
    leave_attendance_type: string;
    leave_status: string;
}

interface EmployeeLeaveRecord {
    leave_id: number;
    leave_ledger_id: number;
    leave_type: string;
    leave_attendance_type: string;
    leave_date_start: string;
    leave_date_end: string;
    leave_remark: string;
    leave_status: string;
}

const breadcrumbItems = [
    { title: 'Employee Attendance' }
];

type CalendarRecord = EmployeeAttendanceRecord | EmployeeLeaveRecord;


const EmployeeAttendance = () => {
    const today = new Date().toISOString().split('T')[0];
    const user = useSelector((state: any) => state.user?.user);
    const [form] = Form.useForm();

    const [ledgers, setLedgers] = useState<Ledgers[]>([]);
    const [selectedLedger, setSelectedLedger] = useState<number | null>(null);
    const [selectedAttendanceId, setSelectedAttendanceId] = useState<number | undefined>(undefined);
    // const [attendanceData, setAttendanceData] = useState<EmployeeAttendanceRecord[]>([]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState<EmployeeAttendanceRecord | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [initialValues, setInitialValues] = useState<EmployeeAttendanceRecord | null>(null);

    const [isLeaveModalVisible, setIsLeaveModalVisible] = useState(false);
    const [initialLeaveValues, setInitialLeaveValues] = useState<EmployeeLeaveRecord | null>(null);
    const [isEditLeaveMode, setIsEditLeaveMode] = useState(false);

    const [attendanceData, setAttendanceData] = useState<CalendarRecord[]>([]);

    const isAttendanceRecord = (record: CalendarRecord): record is EmployeeAttendanceRecord => {
        return 'attendance_id' in record;
    };




    const [loading, setLoading] = useState(false);


    useEffect(() => {
        async function fetchLedgers() {
            try {
                const response = await apiRequest({ method: 'get', url: '/attendance-get-ledger-name' });
                console.log('Ledger data:', response);

                setLedgers(
                    response.ledgers
                        .filter((t: any) => t.ledger_first_name && t.ledger_first_name !== "undefined")
                        .map((t: any) => ({
                            ledger_id: t.ledger_id,
                            ledger_name: `${t.ledger_first_name} ${t.ledger_last_name}`
                        }))
                );
            } catch {
                showError('Failed to load Ledger Names');
            }
        }

        fetchLedgers();
    }, []);

    const fetchAttendance = async (ledgerId: number) => {
        try {
            const data = await apiRequest({
                method: 'get',
                url: `/get-attendance/${ledgerId}`
            });

            setAttendanceData(data);
        } catch {
            showError('Failed to load attendance');
        }
    };

    const fetchLeave = async (ledgerId: number) => {
        try {
            const data = await apiRequest({
                method: 'get',
                url: `/get-leave/${ledgerId}`
            });

            setAttendanceData(data);
        } catch {
            showError('Failed to load leave');
        }
    };




    const handleSubmit = () => {
        if (!selectedLedger) {
            return showError("Please select an employee");
        }

        fetchAttendance(selectedLedger);   // <-- यही आपका attendance_ledger_id बनेगा
        setShowCalendar(true);
    };

    const handleLeave = () => {
        if (!selectedLedger) {
            return showError("Please select an employee");
        }

        fetchLeave(selectedLedger);   // <-- यही आपका attendance_ledger_id बनेगा
        setIsLeaveModalVisible(true);
    };


    // const getListData = (value: Dayjs) => {
    //     // Calendar date in IST
    //     const calendarDateIST = value.tz(IST_ZONE).format("YYYY-MM-DD");

    //     const records = attendanceData.filter(a => {
    //         const recordDateIST = dayjs(a.attendance_date).tz(IST_ZONE).format("YYYY-MM-DD");
    //         return recordDateIST === calendarDateIST;
    //     });

    //     return records.map(a => {
    //         const formatTime = (timeStr: string | null) => {
    //             if (!timeStr) return "--";

    //             let t;
    //             if (/^\d{4}-\d{2}-\d{2}T/.test(timeStr)) {
    //                 t = dayjs.utc(timeStr).tz(IST_ZONE);
    //             } else if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
    //                 const [h, m, s] = timeStr.split(":").map(Number);
    //                 t = dayjs().tz(IST_ZONE).hour(h).minute(m).second(s || 0);
    //             } else return "--";

    //             return t.isValid() ? t.format("hh:mm A") : "--";
    //         };

    //         const attendanceIn = formatTime(a.attendance_in);
    //         const attendanceOut = formatTime(a.attendance_out);

    //         return {
    //             type: a.attendance_type as BadgeProps["status"],
    //             content: (
    //                 <>
    //                     {/* Attendance info */}
    //                     <table style={{ border: '5px' , width:'100%' , margin: '0px' }}>
    //                         <tr>
    //                             <td><strong>IN:</strong> {attendanceIn}</td>
    //                             <td rowSpan={3}>
    //                                 <Button
    //                                     type="text"
    //                                     icon={<EditOutlined />}
    //                                     onClick={() => handleEditClick(a)}
    //                                     style={{ padding: 0 }}
    //                                 />
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <td>
    //                                 <strong>OUT:</strong> {attendanceOut}
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <td>
    //                                 <strong>Remark:</strong> {a.attendance_remark || "--"}
    //                             </td>
    //                         </tr>
    //                     </table>

    //                 </>
    //             ),
    //         };
    //     });
    // };

   const getListData = (value: Dayjs) => {
        const calendarDate = value.format("YYYY-MM-DD");

        // Attendance records for this date
        const attendanceRecords = attendanceData.filter(
            (a): a is EmployeeAttendanceRecord =>
                isAttendanceRecord(a) &&
                dayjs(a.attendance_date).isSame(value, 'day')
        );

        // Leave records spanning this date
        const leaveRecords = attendanceData.filter(
            (l): l is EmployeeLeaveRecord =>
                !isAttendanceRecord(l) &&
                dayjs(l.leave_date_start).isSameOrBefore(value, 'day') &&
                dayjs(l.leave_date_end).isSameOrAfter(value, 'day')
        );


        const attendanceList = attendanceRecords.map(a => {
            const formatTime = (timeStr: string | null) => {
                if (!timeStr) return "--";
                let t;
                if (/^\d{4}-\d{2}-\d{2}T/.test(timeStr)) {
                    t = dayjs.utc(timeStr).tz(IST_ZONE);
                } else if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
                    const [h, m, s] = timeStr.split(":").map(Number);
                    t = dayjs().tz(IST_ZONE).hour(h).minute(m).second(s || 0);
                } else return "--";
                return t.isValid() ? t.format("hh:mm A") : "--";
            };

            return {
                type: a.attendance_type as BadgeProps["status"],
                content: (
                    <table style={{ border: '5px', width: '100%', margin: '0px' }}>
                        <tbody>
                            <tr>
                                <td><strong>IN:</strong> {formatTime(a.attendance_in)}</td>
                                <td rowSpan={3}>
                                    <Button
                                        type="text"
                                        icon={<EditOutlined />}
                                        onClick={() => handleEditClick(a)}
                                        style={{ padding: 0 }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><strong>OUT:</strong> {formatTime(a.attendance_out)}</td>
                            </tr>
                            <tr>
                                <td><strong>Remark:</strong> {a.attendance_remark || "--"}</td>
                            </tr>
                        </tbody>
                    </table>
                ),
            };
        });

        const leaveList = leaveRecords.map(l => ({
            type: "warning" as BadgeProps["status"], // you can change badge color
            content: (
                <div>
                    <strong>Leave:</strong> {l.leave_type} ({l.leave_date_start} - {l.leave_date_end})
                </div>
            ),
        }));

        return [...attendanceList, ...leaveList];
    };

    useEffect(() => {
        console.log("attendanceData raw =>", attendanceData);
        }, [attendanceData]);

    


    const dateCellRender = (value: Dayjs) => {
        const listData = getListData(value);
        return (
            <div className="attendance-list-container">
                <ul className="attendance-list">
                    {listData.map((item, idx) => (
                        <li key={idx}>
                            {item.content} {/* removed Badge dot */}
                        </li>
                    ))}
                </ul>
            </div>
        );
    };


    const monthCellRender = (value: Dayjs) => {
        return null; // optional
    };

    const cellRender: CalendarProps<Dayjs>['cellRender'] = (current, info) => {
        if (info.type === 'date') {
            return dateCellRender(current);
        }
        if (info.type === 'month') {
            return monthCellRender(current);
        }
        return info.originNode;
    };

    // const handleEdit = (record: EmployeeAttendanceRecord) => {
    //     setEditingRecord(record); // set the record to edit
    //     setIsModalVisible(true);   // open the modal
    // };

    const handleCreate = () => {
        if (selectedLedger) {
            fetchAttendance(selectedLedger);
        }
    };



    const handleEditClick = (record: EmployeeAttendanceRecord) => {
        setIsEditMode(true);
        setInitialValues({
            attendance_id: record.attendance_id,
            attendance_ledger_id: record.attendance_ledger_id, // <-- add this
            attendance_date: record.attendance_date,
            attendance_in: record.attendance_in,
            attendance_out: record.attendance_out,
            attendance_type: record.attendance_type,
            attendance_remark: record.attendance_remark,
            leave_attendance_type: record.leave_attendance_type,
            leave_status: record.leave_status,
        });
        setIsModalVisible(true);
    };

    const handleLeaveEditClick = (record: EmployeeLeaveRecord) => {
        setIsEditLeaveMode(true);
        setInitialLeaveValues({
            leave_id: record.leave_id,
            leave_ledger_id: record.leave_ledger_id, // <-- add this
            leave_type: record.leave_type,
            leave_attendance_type: record.leave_attendance_type,
            leave_date_start: record.leave_date_start,
            leave_date_end: record.leave_date_end,
            leave_remark: record.leave_remark,
            leave_status: record.leave_status,
        });
        setIsLeaveModalVisible(true);
    };


    const showCreateModal = () => {
        setIsEditMode(false);
        setInitialValues(null);
        setIsModalVisible(true);
    };

    const hideCreateModal = () => {
        setIsModalVisible(false);
        setIsEditMode(false);
        setInitialValues(null);
    };

    const showCreateLeaveModal = () => {
        setIsEditLeaveMode(false);
        setInitialLeaveValues(null);
        setIsLeaveModalVisible(true);
    };

    const hideCreateLeaveModal = () => {
        setIsLeaveModalVisible(false);
        setIsEditLeaveMode(false);
        setInitialLeaveValues(null);
    };

    return (
        <>
            <Space
                style={{
                    display: 'flex',
                    marginBottom: '16px',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                <Breadcrumb items={breadcrumbItems} />
            </Space>
            <Row gutter={[16, 16]}>
                <Col>
                    <Form
                        form={form}
                        layout="inline"
                        style={{ marginBottom: 16, flexWrap: 'wrap', display: 'flex' }}
                    >
                        <Form.Item
                            name="ledger_id"
                            rules={[{ required: true, message: 'Please select a ledger' }]}
                            style={{ minWidth: 250 }}
                        >
                            <Select
                                placeholder="Select Employee"
                                style={{ width: 240 }}
                                onChange={(value) => {
                                    setSelectedLedger(value);
                                    fetchAttendance(value);
                                }}
                                value={selectedLedger}
                                showSearch
                                optionFilterProp="children"
                            >
                                {ledgers.map((l) => (
                                    <Option key={l.ledger_id} value={l.ledger_id}>
                                        {l.ledger_name}
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                                disabled={!selectedLedger}
                            >
                                Search
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={handleLeave}
                                disabled={!selectedLedger}
                            >
                                Apply Leave
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>


            <Row gutter={[16, 16]}>
                <Col>
                    {showCalendar && (
                        // <Calendar
                        //     cellRender={cellRender} // आपका पहले वाला cellRender logic
                        // />
                        <Calendar
                            cellRender={cellRender}
                            headerRender={({ value, type, onChange, onTypeChange }) => {
                                const months = [
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                ];

                                return (
                                    <div style={{ paddingBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <select
                                                value={value.month()}
                                                onChange={e => {
                                                    const month = Number(e.target.value);
                                                    const newValue = value.clone().month(month);
                                                    onChange(newValue);
                                                }}
                                                style={{ width: 120, padding: 10 }}
                                            >
                                                {months.map((monthName, i) => (
                                                    <option key={i} value={i}>{monthName}</option>
                                                ))}
                                            </select>

                                            <select
                                                value={value.year()}
                                                onChange={e => {
                                                    const year = Number(e.target.value);
                                                    const newValue = value.clone().year(year);
                                                    onChange(newValue);
                                                }}
                                                style={{ width: 80, padding: 10, marginLeft: 8 }}
                                            >
                                                {Array.from({ length: 20 }, (_, i) => 2025 + i).map(y => (
                                                    <option key={y} value={y}>{y}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )
                            }}
                        />


                    )}
                </Col>
            </Row>
            <EmployeeAttendanceModal
                visible={isModalVisible}
                onCancel={hideCreateModal}
                onCreate={handleCreate}
                isEditMode={isEditMode}
                initialValues={initialValues}
            />

            <EmployeeLeaveModal
                visible={isLeaveModalVisible}
                onCancel={hideCreateLeaveModal}
                onCreate={handleCreate}
                isEditLeaveMode={isEditLeaveMode}
                initialLeaveValues={initialLeaveValues}
                ledgerId={selectedLedger}
            />
        </>
    );
};

export default EmployeeAttendance;
